import { ParamsEnum } from './models/params.enum';

export const paramsConfig = {
  page: ParamsEnum.NUMBER,
  search: ParamsEnum.STRING,
  sort: ParamsEnum.STRING,
  isActive: ParamsEnum.BOOLEAN,
  userId: ParamsEnum.NUMBER,
  isDischarged: ParamsEnum.NUMBER,
  userMemberId: ParamsEnum.NUMBER,
  currentPlaceId: ParamsEnum.NUMBER,
  placeOccurrenceId: ParamsEnum.NUMBER,
  place: ParamsEnum.STRING,
  status: ParamsEnum.NUMBER,
  roomId: ParamsEnum.NUMBER,
  areaId: ParamsEnum.NUMBER,
  createdAtStart: ParamsEnum.DATE,
  createdAtEnd: ParamsEnum.DATE,
  startDate: ParamsEnum.DATE,
  endDate: ParamsEnum.DATE,
  roles: ParamsEnum.STRING,
  priority: ParamsEnum.NUMBER,
  requester: ParamsEnum.NUMBER,
  responsibleId: ParamsEnum.NUMBER,
  statusFilter: ParamsEnum.BOOLEAN,
} as const;
